export default __webpack_public_path__ + "assets/images/94204909187006ec6f29e43035c22f38.png";